module.exports = __webpack_public_path__ + "static/media/logo.14d578e6.png";